// extracted by mini-css-extract-plugin
export default {"propertiesSectionDescription":"properties-section-description__properties-section-description__Lpw07"};